<template>
  <div class="d-flex p-3">
    <div
      class="p-3"
      :class="stepActive === 1 ? 'step-active' : 'step-inactive'"
      @click="goToStep(1)"
    >
      <span class="fs-4"> กรอกข้อมูลผู้บริจาค</span>
    </div>
    <div class="p-3">
      <h2>-</h2>
    </div>

    <div
      class="p-3"
      :class="stepActive === 2 ? 'step-active' : 'step-inactive'"
      @click="goToStep(2)"
    >
      <span class="fs-4">เลือกช่องทางบริจาค</span>
    </div>
  </div>
</template>

<script setup>
  defineProps({
  stepActive: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['gotoStep']);

const goToStep = (step) => {
  emit('gotoStep', step);
};
</script>

<style scoped>
.step-active {
  color: #1235a9;
  border: 1px solid #1235a9;
  padding: 16px;
  border-radius: 10px;
  font-size: 1.75rem !important;
  cursor: pointer;
}
.step-inactive {
  color: #a1a3a8;
  cursor: pointer;
}
</style>